import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectSceneSelectionInterval } from '../../element-editor/store/selector/editor.selector';
import { SceneCell } from '../../elements/resource/types/shape.type';

export type LayoutType =
  | 'text'
  | 'title-subtitle'
  | 'images-2'
  | 'images-3'
  | 'image-label'
  | 'video';

export type BaseMargin = 0 | 10 | 20;

@Component({
  selector: 'nw-layout-settings-modal',
  templateUrl: './layout-settings-modal.component.html',
  styleUrls: ['./layout-settings-modal.component.scss'],
})
export class LayoutSettingsModalComponent {
  @Input() sceneIndexOptions: number[] = [];

  @Input() startIndex = 1;
  @Output() startIndexChange = new EventEmitter<number>();

  @Input() endIndex = 1;
  @Output() endIndexChange = new EventEmitter<number>();

  @Input() type: LayoutType = 'text';
  @Output() typeChange = new EventEmitter<LayoutType>();

  @Input() baseMargin: BaseMargin = 10;
  @Output() baseMarginChange = new EventEmitter<BaseMargin>();

  @Output() cancel = new EventEmitter<void>();

  @Output() _save = new EventEmitter<{
    startIndex: number;
    endIndex: number;
    type: LayoutType;
    baseMargin: BaseMargin;
  }>();

  @Output() save = new EventEmitter<SceneCell[]>();

  selectionInterval$: Observable<[number, number]>;

  constructor(private readonly store: Store) {
    this.selectionInterval$ = this.store.select(selectSceneSelectionInterval);
  }

  onStartIndexChange(v: number) {
    this.startIndex = Number(v);
    this.startIndexChange.emit(this.startIndex);
  }

  onEndIndexChange(v: number) {
    this.endIndex = Number(v);
    this.endIndexChange.emit(this.endIndex);
  }

  onTypeChange(v: LayoutType) {
    switch (v) {
      case 'text':
        this.save.emit([
          {
            type: 'text',
            x: 0,
            y: 0,
            w: 1,
            h: 1,
          },
        ]);
        break;
      case 'title-subtitle':
        this.save.emit([
          {
            type: 'text',
            x: 0,
            y: 0,
            w: 1,
            h: 0.5,
          },
          {
            type: 'text',
            x: 0,
            y: 0.5,
            w: 1,
            h: 0.5,
          },
        ]);
        break;
      case 'images-2':
        this.save.emit([
          {
            type: 'text',
            x: 0,
            y: 0,
            w: 0.5,
            h: 1,
          },
          {
            type: 'image',
            x: 0.5,
            y: 0,
            w: 0.5,
            h: 1,
          },
        ]);
        break;
    }
    this.type = v;
    this.typeChange.emit(this.type);

    // Here you can dispatch actions to apply the layout
    // For now, just updating the type
    console.log('Layout type changed to:', v);

    this._save.emit({
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      type: this.type,
      baseMargin: this.baseMargin,
    });
  }

  onBaseMarginChange(v: BaseMargin) {
    this.baseMargin = v;
    this.baseMarginChange.emit(this.baseMargin);
    console.log('Base margin changed to:', v);
  }

  onClose() {
    this.cancel.emit();
  }

  onSave() {
    this._save.emit({
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      type: this.type,
      baseMargin: this.baseMargin,
    });
  }
}
